import debug from 'debug';
const log = debug('mup:updates');

export default function() {
  log('checking for updates -- disabled');

  return Promise.resolve();
}
